import React from 'react'
import Unavbar from '../../components/Uwebsite/UnavbarComp/Unavbar'
import Uabout from '../../components/Uwebsite/UaboutComp/Uabout'
import ContactForm from '../../components/HomeLandingComp/ContactFormComp/ContactForm'
import Footer from '../../components/HomeLandingComp/FooterComp/Footer'
import Uherosection from '../../components/Uwebsite/UherosectionComp/Uherosection'
import Ucollection from '../../components/Uwebsite/UcollectionComp/Ucollection'
import AddtoCart from '../../components/AddtoCartComp/AddtoCart'

const Ulayout = () => {
  return (
    <div>
        {/* <Unavbar /> */}
        <Uherosection />
        <Uabout />
        <Ucollection />
        <ContactForm />
        <Footer />
        {/* <AddtoCart /> */}
    </div>
  )
}

export default Ulayout